export class AssetLoader {
  constructor() {
    this.totalAssets = 0;
    this.loadedAssets = 0;
    this.onProgressCallback = null;
  }

  setOnProgress(callback) {
    this.onProgressCallback = callback;
  }

  async loadConfig(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to load config: ${response.statusText}`);
      }
      const config = await response.json();
      return config;
    } catch (error) {
      console.error('Error loading config:', error);
      throw error;
    }
  }

  async preloadVideos(paintings) {
    this.totalAssets = paintings.length;
    this.loadedAssets = 0;

    const videoPromises = paintings.map((painting) => {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = painting.videoUrl;
        video.preload = 'metadata';

        video.addEventListener('loadedmetadata', () => {
          this.loadedAssets++;
          this.updateProgress();
          resolve(video);
        });

        video.addEventListener('error', (e) => {
          console.warn(`Failed to load video: ${painting.videoUrl}`, e);
          this.loadedAssets++;
          this.updateProgress();
          resolve(null); // Resolve with null instead of rejecting
        });

        // Set a timeout in case the video doesn't load
        setTimeout(() => {
          if (video.readyState < 1) {
            console.warn(`Video loading timeout: ${painting.videoUrl}`);
            this.loadedAssets++;
            this.updateProgress();
            resolve(null);
          }
        }, 10000); // 10 second timeout
      });
    });

    await Promise.all(videoPromises);
    return true;
  }

  updateProgress() {
    const progress = this.totalAssets > 0 ? this.loadedAssets / this.totalAssets : 0;
    if (this.onProgressCallback) {
      this.onProgressCallback(progress);
    }
  }

  getProgress() {
    return this.totalAssets > 0 ? this.loadedAssets / this.totalAssets : 0;
  }
}
